/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Message
 * @export
 * @interface InternalApiCreateAlertRfiMessage
 */
export interface InternalApiCreateAlertRfiMessage {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateAlertRfiMessage
     */
    content: string;
    /**
     * Message attachment ids
     * @type {Array<string>}
     * @memberof InternalApiCreateAlertRfiMessage
     */
    attachmentIds?: Array<string>;
}

/**
 * Check if a given object implements the InternalApiCreateAlertRfiMessage interface.
 */
export function instanceOfInternalApiCreateAlertRfiMessage(value: object): value is InternalApiCreateAlertRfiMessage {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCreateAlertRfiMessageFromJSON(json: any): InternalApiCreateAlertRfiMessage {
    return InternalApiCreateAlertRfiMessageFromJSONTyped(json, false);
}

export function InternalApiCreateAlertRfiMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateAlertRfiMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'attachmentIds': json['attachmentIds'] == null ? undefined : json['attachmentIds'],
    };
}

export function InternalApiCreateAlertRfiMessageToJSON(json: any): InternalApiCreateAlertRfiMessage {
    return InternalApiCreateAlertRfiMessageToJSONTyped(json, false);
}

export function InternalApiCreateAlertRfiMessageToJSONTyped(value?: InternalApiCreateAlertRfiMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'attachmentIds': value['attachmentIds'],
    };
}

